import { type CombinedError, mapExchange, type Operation } from "@urql/next"
import type { ErrorHandler } from "../../types"
import { getOperationName } from "../../utils"

export const errorExchange = (handler: ErrorHandler) =>
  mapExchange({
    onError: (error: CombinedError, operation: Operation) => {
      const operationName = getOperationName(operation)
      const query = operation.query.loc?.source.body || "Error parsing query"
      const variables = operation.variables || {}

      handler(error, {
        operationName,
        query,
        variables,
        kind: operation.kind,
      })
    },
  })
